import { getColor, mode } from '@chakra-ui/theme-tools'

// https://github.com/chakra-ui/chakra-ui/blob/master/packages/theme/src/components/input.ts
const size = {
  md: {
    fontSize: 'sm',
    height: '3.5rem',
    borderRadius: 'lg',
  },
  sm: {
    fontSize: 'sm',
    height: '2.5rem',
    borderRadius: 'lg',
  },
}

export const Input = {
  baseStyle: {
    field: {
      transition: 'all 0.2s ease-in-out',
      '::placeholder': { color: 'gray.600' },
    },
  },
  variants: {
    outline: (props) => {
      const { theme, colorScheme, focusBorderColor, errorBorderColor } = props
      const fc = focusBorderColor || mode(colorScheme ? `${colorScheme}.500` : 'gray.800', 'blue.300')(props)
      const ec = errorBorderColor || mode('red.500', 'red.300')(props)

      return {
        field: {
          _disabled: {
            opacity: 1,
            color: 'gray.700',
            bgColor: 'gray.50',
          },
          _focus: {
            borderColor: getColor(theme, fc),
            boxShadow: `outline-${colorScheme}`,
            _readOnly: { boxShadow: `${theme.shadows[`outline-${colorScheme}`]}!important` },
          },
          _invalid: {
            borderColor: getColor(theme, ec),
            boxShadow: 'none',
          },
        },
      }
    },
  },
  sizes: {
    md: {
      field: size.md,
      addon: size.md,
    },
    sm: {
      field: size.sm,
      addon: size.sm,
    },
  },
}
